
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"53","height":"52","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.2 42.246v-16.25m.001.004h1.625a4.875 4.875 0 110 9.75h-1.625m13 6.5a6.5 6.5 0 006.5-6.5V32.5a6.5 6.5 0 00-6.5-6.5v16.25zm13 0v-13a3.25 3.25 0 013.25-3.25h3.25M36.2 35.746h4.874","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M49.87 12.045a3.25 3.25 0 01.954 2.297V45.5a4.875 4.875 0 01-4.873 4.871h-39a4.875 4.875 0 01-4.877-4.87v-39a4.875 4.875 0 014.877-4.88h31.15a3.25 3.25 0 012.3.951l9.47 9.473z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M37.824 1.621v9.75a3.25 3.25 0 003.25 3.25h9.75","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    